import React from "react";

export default function PizzaSizeModalitiesEditor({ options, onChange }) {
  return <div style={{ display: "grid", gap: 12 }}>
    {options.map((option, index) => {
      const active = option.active !== false;
      const halfPriceEnabled = option.sellHalf || option.allowHalfAndHalf;
      const inputStyle = { width: "100%", minWidth: 0, padding: 10, border: "1px solid #cbd5e1", borderRadius: 8, boxSizing: "border-box" };
      const price = (field, label, enabled, step = "0.01") => <label style={{ display: "grid", gap: 6 }}>
        <span>{label}</span><input type="number" min="0" step={step} value={option[field] || ""}
          aria-label={`${label} ${option.label}`} disabled={!active || !enabled}
          onChange={(event) => onChange(index, { [field]: event.target.value })}
          style={{ ...inputStyle, background: active && enabled ? "#fff" : "#e2e8f0" }} />
      </label>;
      return <fieldset key={index} style={{ border: "1px solid #cbd5e1", borderRadius: 12, padding: 14, minWidth: 0, background: active ? "#fff" : "#f1f5f9" }}>
        <legend><label><input type="checkbox" checked={active} aria-label={`Ofrecer tamano ${option.label}`}
          onChange={(event) => onChange(index, { active: event.target.checked })} /> {option.label}</label></legend>
        <label>Nombre del tamano<input value={option.label} aria-label={`Nombre del tamano ${option.label}`}
          disabled={!active} style={inputStyle} onChange={(event) => onChange(index, { label: event.target.value })} /></label>
        <div style={{ display: "grid", gap: 10, margin: "14px 0" }}>
          {[["sellWhole", "Vender pizza entera"], ["sellHalf", "Vender media pizza"],
            ["allowHalfAndHalf", "Permitir combinacion mitad y mitad"], ["sellSlice", "Vender por porcion"]].map(([field, label]) =>
            <label key={field}><input type="checkbox" checked={option[field] === true} disabled={!active}
              aria-label={`${label} ${option.label}`} onChange={(event) => onChange(index, { [field]: event.target.checked })} /> {label}</label>)}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12 }}>
          {price("fullPrice", "Precio entera", option.sellWhole)}
          {price("halfPrice", halfPriceEnabled && !option.sellHalf ? "Precio de la mitad para combinar" : "Precio media pizza", halfPriceEnabled)}
          {price("slicePrice", "Precio porcion", option.sellSlice)}
          {price("slices", "Porciones por pizza", option.sellSlice, "1")}
        </div>
        <p style={{ color: "#53647e", marginBottom: 0 }}>
          {active && option.sellWhole && !option.sellHalf && !option.allowHalfAndHalf && !option.sellSlice
            ? "Este tamano se vende solo como pizza entera. Cada unidad del pedido es una pizza completa."
            : "Solo se ofrecen las modalidades marcadas. Los precios guardados no activan otras modalidades."}
          {active && option.allowHalfAndHalf ? " Mitad y mitad suma el precio de la mitad de cada sabor habilitado." : ""}
          {active && option.sellSlice ? " El stock por porcion consume la fraccion indicada de la receta del tamano." : ""}
        </p>
      </fieldset>;
    })}
  </div>;
}
